import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { UiIcon } from 'ui-components';
import { isUndefined } from 'lib';
import { StyledFilterItemWrapper } from './FilterList.styles';

export default function FilterList({
  sliceModule,
  mapToComponent,
  togglable = false,
  allowedFilters,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const filters = useSelector(
    (state) => state[state.filterReducer.filtersContext]?.filters
  );

  const selectedFilter = useSelector(
    (state) => state[state.filterReducer.filtersContext]?.selectedFilter
  );

  const allFilters = Object.keys(filters || []).filter(
    (key) => !allowedFilters?.length || allowedFilters.includes(key)
  );

  const handleSelectFilter = (componentName) => {
    dispatch(sliceModule?.setSelectedFilter(componentName));
  };

  return (
    <>
      {allFilters.map((key) => {
        const { title, translateKey, componentName, hasFilter } = filters[key];

        const Component = mapToComponent[componentName];

        if (!Component) {
          return null;
        }
        return (
          <StyledFilterItemWrapper>
            <div
              className={classNames(
                'filter-item',
                selectedFilter === key && 'selected',
                hasFilter && 'has-filter'
              )}
              onClick={() => handleSelectFilter(componentName)}
              key={key}
            >
              <div className='title'>
                <div>{t(title || translateKey)}</div>
                <UiIcon icon='icon ri-arrow-left-s-line' />
              </div>
              <div className='sub-title'>
                {t(`filter:${componentName}SubTitle`)}
              </div>
            </div>
            {!isUndefined(Component) &&
              selectedFilter === componentName &&
              togglable && (
                <Component componentName={selectedFilter} className='filter' />
              )}
          </StyledFilterItemWrapper>
        );
      })}
    </>
  );
}

FilterList.propTypes = {
  sliceModule: PropTypes.object,
  mapToComponent: PropTypes.object,
  togglable: PropTypes.bool,
  allowedFilters: PropTypes.arrayOf(PropTypes.string),
};
